// multiImageClip 클래스 정의
class MultiImageClip {
    constructor({
                    imageClip_path,
                    start_time,
                    end_time,
                    start_frame = 0,
                    end_frame = 0,
                    reversed = false,
                    current_viseme = null,
                    last_viseme = null
                }) {
        this.imageClip_path = imageClip_path;
        this.start_time = start_time;
        this.end_time = end_time;
        this.start_frame = start_frame;
        this.end_frame = end_frame;
        this.reversed = reversed;
        this.current_viseme = current_viseme;
        this.last_viseme = last_viseme;
    }
}

// Azure viseme 매핑
const azure_viseme_mapping_dic = {
    0: 'b', 1: 'a', 2: 'a', 3: 'o', 4: 'i', 5: 'a', 6: 'i', 7: 'u', 8: 'o', 9: 'o',
    10: 'o', 11: 'i', 12: 'a', 13: 'a', 14: 'a', 15: 'ch', 16: 'ch', 17: 'ch', 18: 'f',
    19: 'ch', 20: 'ch', 21: 'b'
};

const viseme2imageClip_dic = {
    'fa': 'fa', 'cha': 'fa', 'ba': 'ba', 'fo': 'fo', 'cho': 'fo', 'bo': 'bo',
    'fu': 'fu', 'chu': 'fu', 'bu': 'bu', 'fi': 'fi', 'chi': 'chi', 'bi': 'bi',
    'ai': 'ai', 'ao': 'ao', 'au': 'au', 'io': 'io', 'iu': 'iu', 'ou': 'ou',
    'chf': 'chf', 'bf': 'bf', 'bch': 'bch'
};

const simplify_set = new Set([
    // 파이썬 simplify_set 주석 처리된 부분은 생략
]);

const transition_dic = {
    'ai': [1, 1], 'ao': [3, 3], 'au': [3, 3], 'io': [1, 1], 'iu': [1, 1], 'ou': [3, 3],
    'ba': [4, 4], 'bi': [0, 1], 'bu': [4, 0], 'chi': [1, 2], 'fa': [0, 3], 'fi': [4, 1],
    'fo': [4, 0], 'fu': [6, 3], 'po': [0, 1]
};

const closed_mouth_sound_set = new Set([
    // 'b', 'f'
]);

function visemeSimplify(viseme_data) {
    if (!simplify_set.size) return viseme_data;
    const viseme_name = viseme_data[0].hasOwnProperty('viseme') ? 'viseme' : 'id';
    let i = 0;
    const simplified_viseme_data = [];
    while (i < viseme_data.length) {
        if (i + 2 < viseme_data.length) {
            const triple = [
                viseme_data[i][viseme_name],
                viseme_data[i + 1][viseme_name],
                viseme_data[i + 2][viseme_name]
            ];
            if (simplify_set.has(JSON.stringify(triple))) {
                console.log('simplify triple:', triple);
                simplified_viseme_data.push(viseme_data[i]);
                i += 3;
                continue;
            }
        }
        if (i + 1 < viseme_data.length) {
            const pair = [
                viseme_data[i][viseme_name],
                viseme_data[i + 1][viseme_name]
            ];
            if (simplify_set.has(JSON.stringify(pair))) {
                console.log('simplify pair:', pair);
                simplified_viseme_data.push(viseme_data[i]);
                i += 2;
                continue;
            }
        }
        const single = viseme_data[i][viseme_name];
        if (simplify_set.has(single)) {
            i += 1;
            console.log('simplify single:', single);
            continue;
        }
        simplified_viseme_data.push(viseme_data[i]);
        i += 1;
    }
    return simplified_viseme_data;
}

function imageClipSimplify(imageClip_list) {
    const simplified_imageClip = [];
    let i = 0;
    while (i < imageClip_list.length) {
        const ic = imageClip_list[i];
        if (i === 0) {
            simplified_imageClip.push(new MultiImageClip({
                imageClip_path: ic.imageClip_path,
                start_time: ic.start_time,
                end_time: ic.end_time,
                start_frame: 0,
                end_frame: 0,
                reversed: ic.reversed
            }));
        } else {
            if (!ic.imageClip_path) {
                console.log('!!!! None image path !!!!!');
                i++;
                continue;
            }
            if (
                transition_dic.hasOwnProperty(ic.imageClip_path) &&
                simplified_imageClip.length &&
                simplified_imageClip[simplified_imageClip.length - 1].imageClip_path === ic.imageClip_path &&
                simplified_imageClip[simplified_imageClip.length - 1].reversed !== ic.reversed
            ) {
                if (
                    viseme2imageClip_dic.hasOwnProperty(ic.last_viseme + ic.current_viseme) &&
                    transition_dic.hasOwnProperty(viseme2imageClip_dic[ic.last_viseme + ic.current_viseme]) &&
                    !ic.reversed
                ) {
                    simplified_imageClip[simplified_imageClip.length - 1].start_frame = transition_dic[ic.imageClip_path][0];
                    simplified_imageClip.push(new MultiImageClip({
                        imageClip_path: ic.imageClip_path,
                        start_time: ic.start_time,
                        end_time: ic.end_time,
                        start_frame: transition_dic[ic.imageClip_path][0],
                        end_frame: 0,
                        reversed: ic.reversed
                    }));
                } else if (
                    viseme2imageClip_dic.hasOwnProperty(ic.current_viseme + ic.last_viseme) &&
                    transition_dic.hasOwnProperty(viseme2imageClip_dic[ic.current_viseme + ic.last_viseme]) &&
                    ic.reversed
                ) {
                    simplified_imageClip[simplified_imageClip.length - 1].end_frame = transition_dic[ic.imageClip_path][1];
                    simplified_imageClip.push(new MultiImageClip({
                        imageClip_path: ic.imageClip_path,
                        start_time: ic.start_time,
                        end_time: ic.end_time,
                        start_frame: 0,
                        end_frame: transition_dic[ic.imageClip_path][1],
                        reversed: ic.reversed
                    }));
                } else {
                    simplified_imageClip.push(new MultiImageClip({
                        imageClip_path: ic.imageClip_path,
                        start_time: ic.start_time,
                        end_time: ic.end_time,
                        start_frame: 0,
                        end_frame: 0,
                        reversed: ic.reversed
                    }));
                }
            } else {
                simplified_imageClip.push(new MultiImageClip({
                    imageClip_path: ic.imageClip_path,
                    start_time: ic.start_time,
                    end_time: ic.end_time,
                    start_frame: 0,
                    end_frame: 0,
                    reversed: ic.reversed
                }));
            }
        }
        i++;
    }
    return simplified_imageClip;
}

function sequential_filter_viseme_data(viseme_data, viseme_name = "id", rest_ratio = 0.3) {
    const n = viseme_data.length;
    const remain_viseme_set = new Set([3, 10, 1, 2]);
    if (n <= 4 || rest_ratio >= 1.0) return viseme_data.slice();
    const must_keep_indices = new Set([0, 1, n - 2, n - 1]);
    for (let i = 0; i < n; i++) {
        if (viseme_data[i][viseme_name] === 0) {
            must_keep_indices.add(i);
            if (i - 1 >= 0) must_keep_indices.add(i - 1);
            if (i + 1 < n) must_keep_indices.add(i + 1);
        }
    }
    const remaining_indices = [];
    for (let i = 2; i < n - 2; i++) remaining_indices.push(i);
    const keep_middle_count = Math.max(1, Math.floor(remaining_indices.length * rest_ratio));
    const step = remaining_indices.length / keep_middle_count;
    const selected_middle_indices = new Set();
    const attempt_limit = keep_middle_count * 2;
    let i = 0;
    while (selected_middle_indices.size < keep_middle_count && i < attempt_limit) {
        const raw_idx = Math.floor(i * step);
        if (raw_idx >= remaining_indices.length) break;
        const idx = remaining_indices[raw_idx];
        let preferred_idx = null;
        for (const offset of [0, -1, 1]) {
            const neighbor_idx = idx + offset;
            if (
                neighbor_idx >= 2 && neighbor_idx < n - 2 &&
                !selected_middle_indices.has(neighbor_idx)
            ) {
                const neighbor_vid = viseme_data[neighbor_idx][viseme_name];
                if (remain_viseme_set.has(neighbor_vid)) {
                    preferred_idx = neighbor_idx;
                    break;
                }
            }
        }
        if (preferred_idx === null && !selected_middle_indices.has(idx)) {
            preferred_idx = idx;
        }
        if (preferred_idx !== null) selected_middle_indices.add(preferred_idx);
        i++;
    }
    const selected_indices = new Set([...must_keep_indices, ...selected_middle_indices]);
    return viseme_data.filter((v, i) => selected_indices.has(i));
}

export function multi_viseme2imageClipSequence(viseme_data) {
    if (!viseme_data || !viseme_data.length) throw new Error("Empty viseme_data provided");
    try {
        const imageClip_list = [];
        let start_time = 0;
        let last_viseme = 'b';
        const viseme_name = viseme_data[0].hasOwnProperty('viseme') ? 'viseme' : 'id';
        const time_multiplier = 1e7;
        const rest_ratio = 0.4;
        const filtered_viseme_data = sequential_filter_viseme_data(viseme_data, viseme_name, rest_ratio);
        console.log(`select ratio:${rest_ratio}, real ratio:${(filtered_viseme_data.length / viseme_data.length).toFixed(2)}`);
        const simplified_viseme_data = visemeSimplify(filtered_viseme_data);
        for (let i = 0; i < simplified_viseme_data.length; i++) {
            const dic = simplified_viseme_data[i];
            if (!(viseme_name in dic) || !('offset' in dic)) throw new Error(`Missing required keys in dictionary: ${JSON.stringify(dic)}`);
            const current_viseme = azure_viseme_mapping_dic[dic[viseme_name]];
            const end_time = dic['offset'] / time_multiplier;
            if (current_viseme === last_viseme) continue;
            const sequence = last_viseme + current_viseme;
            let reverse_flag = false;
            let imageClip_path = null;
            if (viseme2imageClip_dic.hasOwnProperty(sequence)) {
                imageClip_path = viseme2imageClip_dic[sequence];
            } else {
                const reversed_sequence = current_viseme + last_viseme;
                if (!viseme2imageClip_dic.hasOwnProperty(reversed_sequence)) {
                    throw new Error(`Neither sequence ${sequence} nor its reverse exists in viseme2imageClip_dic`);
                }
                imageClip_path = viseme2imageClip_dic[reversed_sequence];
                reverse_flag = true;
            }
            imageClip_list.push(new MultiImageClip({
                imageClip_path,
                start_time,
                end_time,
                reversed: reverse_flag,
                current_viseme,
                last_viseme
            }));
            start_time = end_time;
            last_viseme = current_viseme;
        }
        const simplified_imageClip_list = imageClipSimplify(imageClip_list);
        return simplified_imageClip_list;
    } catch (e) {
        console.log(`Error in viseme2imageClip: ${e}`);
        throw e;
    }
}